import {Hint} from '@/components/ui/hint'
import {Input} from '@/components/ui/input'
import {Label} from '@/components/ui/label'

export function DateField({
  id,
  label,
  value,
  min,
  max,
  hint,
  disabled,
  onChange,
}: {
  id: string
  label: string
  value: string
  min?: string
  max?: string
  /** ≤ 12 palabras (T2); lo que no quepa va en un `InfoTip`. */
  hint?: string
  disabled?: boolean
  onChange: (value: string) => void
}) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type="date"
        className="max-w-45 font-mono"
        value={value}
        min={min}
        max={max}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
      {hint && <Hint>{hint}</Hint>}
    </div>
  )
}
